<ion-app class="noselect" darkMode largeFont>
  <ion-split-pane contentId="main-content">
    <app-side-menu *ngIf="showMenu"></app-side-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
